import { ScanTemplateValueType } from '@kaiizen/kai-scan-template-system';

const NUMERIC_TEMPLATE_VALUE_TYPES: ScanTemplateValueType[] = [
  'count',
  'usd',
  'sqft',
  'ft',
  'in',
  'acres',
  'fahrenheit',
  'year',
];

const CLEAN_NUMERIC_VALUE_REGEX = /^-?([0-9]+(\.[0-9]*)?|\.[0-9]+)$/;

const cleanNumericInput = (value: string) => value.replace(/[\s,$]/g, '');

export const parseTemplateNumericInput = (value: string): number | undefined => {
  const cleaned = cleanNumericInput(value);
  if (!CLEAN_NUMERIC_VALUE_REGEX.test(cleaned)) return undefined;
  return Number(cleaned);
};

export const parseScanTemplateDefaultValueOrEquationString = (value: string): string | number | null => {
  const parsedNumericValue = parseTemplateNumericInput(value);
  if (parsedNumericValue != null) return parsedNumericValue;

  const trimmed = value.trim();
  return trimmed ? trimmed : null;
};

export const normalizeTemplateValueInput = (
  value: string,
  valueType?: ScanTemplateValueType,
): string | number | undefined => {
  if (valueType && NUMERIC_TEMPLATE_VALUE_TYPES.includes(valueType)) {
    const parsedValue = parseScanTemplateDefaultValueOrEquationString(value);
    return parsedValue === null ? undefined : parsedValue;
  }
  return value || undefined;
};
